export default "__VITE_ASSET__BOwdU98b__"